<div class="mat-typography">
    <div class="mat-typography content">
        <h4 class="statistic-section-header">Momentum cache size statistic</h4>
        <p>Max Entities allowed: {{ gisDataCacheStatistic?.maxSize }}</p>
        <p>Entities cached: {{ gisDataCacheStatistic?.size }}</p>
        <p>Cache size usage: {{ gisDataCacheStatistic?.sizeUsage }}%</p>
        <p>Max Entities volume allowed (Kb): {{ bytesToKiloBytes(gisDataCacheStatistic?.maxSizeBytes) }}</p>
        <p>Calculated size (Kb): {{ bytesToKiloBytes(gisDataCacheStatistic?.calculatedSizeBytes) }}</p>
        <p>Cache volume size usage: {{ gisDataCacheStatistic?.sizeBytesUsage }}%</p>
        <p>Entity time to live (s): {{ millisecondsToSeconds(gisDataCacheStatistic?.ttl) }}</p>
        <p>Time to live resolution (s): {{ millisecondsToSeconds(gisDataCacheStatistic?.ttlResolution) }}</p>
        <h4 class="statistic-section-header">Cache operations statistic (counts adding operations, not deletion
            operations)</h4>
        <p>Total PRs added: {{ gisDataCacheStatistic?.totalPRsAddOperations }}</p>
        <p>Total Streets added: {{ gisDataCacheStatistic?.totalStreetsAddOperations }}</p>
        <p>Total PR Tags added: {{ gisDataCacheStatistic?.totalPRTagsAddOperations }}</p>
        <p>Total cached data size (Kb): {{ bytesToKiloBytes(gisDataCacheStatistic?.totalCalculatedSizeBytes) }}</p>
        <p>Removed from cache data size (Kb): {{gisDataCacheStatistic?
            bytesToKiloBytes(gisDataCacheStatistic.totalCalculatedSizeBytes-gisDataCacheStatistic.calculatedSizeBytes):0
            }}</p>
    </div>
</div>
